export const getBAName = ({ firstName, lastName, isTeamLeader }) =>
  `${isTeamLeader ? '⭐' : ''} ${firstName} ${lastName}`



// WEBPACK FOOTER //
// ./src/Utils/User/index.js